import React from 'react'
import { useTranslation } from 'react-i18next';
import RegistrationFormSection from './RegistrationFormSection'
import RegistrationFormCertification from './RegistrationFormCertification';
import { RegistrationFormSupertitleSection } from './RegistrationFormStyleSection';


const RegistrationFormCasterSectionOffreur = ({ title, instructions, formulaire,
    displayCollectifsGeographiquesSection,
    setDisplayCollectifsGeographiquesSection,
    displayEventSection,
    setDisplayEventSection,
    displayTechFundRaiserSection,
    setDisplayTechFundRaiserSection,
    setDisplayContactCommunauteSection,
    displayContactCommunauteSection,
    contact }) => {
    const { t } = useTranslation();

    return (
        <>
            {
                !['27'].includes(formulaire.id_formulaire) && <RegistrationFormCertification
                    supertitle={<RegistrationFormSupertitleSection>{t('form.sections.certification.section_supertitle')}</RegistrationFormSupertitleSection>}
                    instructions={t('form.sections.certification.section_instructions')}
                    contact={contact} />


            }

            <RegistrationFormSection
                supertitle={<RegistrationFormSupertitleSection>Vos leviers de développement prioritaires </RegistrationFormSupertitleSection>}

                title_="Prochaines étapes : faisons connaissance et précisez ce que vous recherchez…"
                instructions="Le pitch de 90 secondes que vous avez réalisé pour myGlovbalVillage était une première étape. Afin de mieux vous connaitre et de vous accompagner dans votre démarche d’accélération, selon votre stade de développement de startup/produit, détaillez ci-dessous vos besoins en matière de développement international (plusieurs cases possibles) :"
                instructions_={t('form.sections.global_funding_connector.section_title')}>

                <p className="p-3">Je précise mes objectifs internationaux :</p>
                <div className="flex flex-col pl-10">
                    <label className="font-normal">
                        <input
                            type="checkbox"
                            onChange={() => setDisplayTechFundRaiserSection(!displayTechFundRaiserSection)} />
                        <b> Je recherche des investisseurs pour mon prochain round de levée de fond </b>
                        [Bloc I1 - Accompagnement à la détection d’investisseurs internationaux]
                        {
                            " "
                            //t('form.sections.global_funding_connector.cherche_investisseurs')
                        }
                    </label>

                    <label className="font-normal ">
                        <input
                            type="checkbox"
                            onChange={() => setDisplayCollectifsGeographiquesSection(!displayCollectifsGeographiquesSection)} />
                        <b> Je recherche des distributeurs dans de nombreux pays pour mon accélération </b>
                        [Bloc D1 Accompagnement au recrutement de Distributeurs, intégrateurs et revendeurs internationaux]
                        {
                            "	"
                            //t('form.sections.global_funding_connector.cherche_revendeurs')
                        }
                    </label>

                    <label className="font-normal">
                        <input
                            type="checkbox"
                            onChange={() => setDisplayContactCommunauteSection(!displayContactCommunauteSection)}
                        /> <b>Je recherche des clients finaux</b> [Bloc C1 - Accompagnement à la détection et prospection de clients finaux internationaux pour vos produits/services]
                        {
                            //t('form.sections.global_funding_connector.cherche_clients_finaux')
                        }
                    </label>

                    <label className="font-normal">
                        <input
                            type="checkbox"
                            onChange={() => setDisplayEventSection(!displayEventSection)}
                        /> <b>J’ai prévu de me rendre sur des événements de mon secteur </b>
                        [Bloc E1 – convergence et chasse en groupe coordonnée sur les événements de mon secteur]
                    </label>
                </div>

                <p className="p-3">Chaque case cochée, fais apparaitre un des .4 blocs ci-dessus afin de préciser vos besoins et les prochaines étapes que nous allons mettre en œuvre.</p>
            </RegistrationFormSection >
        </>
    )
}

export default RegistrationFormCasterSectionOffreur